import request from './request'

export const getRunnerReferrerList = (params) => {
  return request({
    url: '/admin/runner-referrers',
    method: 'get',
    params
  })
}

export const getRunnerReferrerDetail = (id) => {
  return request({
    url: `/admin/runner-referrers/${id}`,
    method: 'get'
  })
}

export const createRunnerReferrer = (data) => {
  return request({
    url: '/admin/runner-referrers',
    method: 'post',
    data
  })
}

export const updateRunnerReferrer = (id, data) => {
  return request({
    url: `/admin/runner-referrers/${id}`,
    method: 'put',
    data
  })
}

export const deleteRunnerReferrer = (id) => {
  return request({
    url: `/admin/runner-referrers/${id}`,
    method: 'delete'
  })
}
